(function () {
  'use strict';
  // The modal's one button (#1123, Grant 2026-10-02). Sizes stay on the page
  // (no size row in the modal: fewest rows on a phone, and the page behind a
  // showModal() dialog is inert). Size picked on the page -> "Add to bag" adds
  // at the price the page resolved (the "(Personalized ×k)" tier). No size
  // yet -> "Save and choose size" saves, closes and sends the shopper to the
  // page's size row; the page's own Add to Bag then carries the tier. Pure:
  // the inputs are read off the PDP, which owns size, variant, tier and stock.
  function addToBagState(input) {
    if (input.blocked) return { action: 'none', label: 'Personalization unavailable', price: '' };
    if (!input.sizeSelected) return { action: 'save', label: 'Save and choose size', price: input.addonText || '' };
    if (input.unavailableLabel) return { action: 'none', label: input.unavailableLabel, price: '' };
    return { action: 'add', label: 'Add to bag', price: input.priceText || '' };
  }
  // The page's entry button says what this store sells (ghostfit.personalization_mode,
  // on #ghostfit-school-colors). Set here so the live hero needs no edit. Both or
  // unknown keeps the hero's own label. Pure.
  function entryLabelForMode(mode, fallback) {
    if (mode === 'numbers_only') return 'Add a number';
    if (mode === 'names_only') return 'Add a name';
    return fallback;
  }
  function storePersonalizationMode() {
    try {
      const el = document.getElementById('ghostfit-school-colors');
      return (el && JSON.parse(el.textContent).mode) || '';
    } catch (e) {
      return '';
    }
  }
  // The edit screen's button on a product with the review step: it leads to the
  // review, whose own button adds. Stock or tier problems still say so here.
  function editButtonState(state, reviewable, addon) {
    if (!reviewable || state.action === 'none') return { label: state.label, price: state.price };
    return { label: 'Review', price: addon };
  }
  // Written on the cart line when the tick is checked. Bump it if the tick's
  // wording changes: "I checked the spelling and the numbers. We'll print it as shown."
  const REVIEW_VERSION = 'spelling-v1';
  let dispose = function () {};
  let mountedDialog;
  let mountedEntry;

  function init() {
    const dialog = document.getElementById('gf-pz-dialog');
    const entry = document.querySelector('[data-gf-pz-entry]');
    if (!dialog || (dialog === mountedDialog && entry === mountedEntry)) return;
    dispose();
    mountedDialog = dialog;
    mountedEntry = entry;
    dialog.dataset.premiumBound = 'true';
    const listeners = new AbortController();
    const signal = listeners.signal;
    const on = (target, type, handler, capture) => target.addEventListener(type, handler, { signal: signal, capture: !!capture });
    const save = dialog.querySelector('[data-gf-pz-save]');
    const notice = dialog.querySelector('#gf-pz-unavailable');
    const reviewEl = dialog.querySelector('[data-gf-pz-review]');
    const reviewTitle = dialog.querySelector('#gf-pz-review-title');
    const reviewViews = dialog.querySelector('[data-gf-pz-review-views]');
    const reviewSpots = dialog.querySelector('[data-gf-pz-review-spots]');
    const reviewOk = dialog.querySelector('[data-gf-pz-review-ok]');
    const reviewAdd = dialog.querySelector('[data-gf-pz-review-add]');
    const reviewError = dialog.querySelector('#gf-pz-review-error');
    const reviewBack = dialog.querySelector('[data-gf-pz-review-back]');
    const entryStatus = entry && (entry.querySelector('[data-gf-pz-status]') || (() => {
      const status = document.createElement('p');
      status.className = 'gf-pz-entry__status';
      status.dataset.gfPzStatus = 'true';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.hidden = true;
      entry.appendChild(status);
      return status;
    })());
    const included = dialog.dataset.includedLabel || 'Included';
    const productHandle = (window.location.pathname.match(/\/products\/([a-z0-9][a-z0-9_-]*)/i) || [])[1] || null;
    let analyticsAction = 0;
    function analytics(eventName, payload) { if (window.GhostfitAnalytics && typeof window.GhostfitAnalytics.track === 'function') window.GhostfitAnalytics.track(eventName, payload); }
    function activePlacement() {
      const chip = dialog.querySelector('[data-wi-location-chip][aria-pressed="true"]');
      return chip ? chip.dataset.wiLocationChip : null;
    }
    let engine = window.GhostFitPersonalization;
    let savedSnapshot = engine && engine.snapshot();
    let savedStatus = engine && engine.status();
    let editing = false;
    let opener;

    function money(cents) {
      const sample = document.getElementById('pd-cta-price');
      return String(sample ? sample.textContent : '$0.00').replace(/[\d.,]+/, (cents / 100).toFixed(2));
    }
    function addonText(status) {
      return status.addonCents ? '+' + money(status.addonCents) : included;
    }
    function feedback(kind, text) {
      dialog.dataset.feedback = kind || '';
      if (entry) entry.dataset.feedback = kind || '';
      if (notice) {
        notice.textContent = text || '';
        notice.hidden = !text;
        notice.dataset.feedback = kind || '';
      }
      if (entryStatus) {
        entryStatus.textContent = text || '';
        entryStatus.hidden = !text;
        entryStatus.dataset.feedback = kind || '';
      }
    }
    function message(text) {
      if (!text) dialog.querySelectorAll('[aria-errormessage="gf-pz-unavailable"]').forEach(field => {
        field.removeAttribute('aria-invalid');
        field.removeAttribute('aria-errormessage');
      });
      feedback(text ? 'error' : '', text);
    }
    function showValidation(validation) {
      message('');
      // Use the engine's own location switch (a chip click) so the current
      // draft is kept and the invalid location's type, fields and preview return.
      const chip = validation.locationId
        ? Array.from(dialog.querySelectorAll('[data-wi-location-chip]')).find(c => c.dataset.wiLocationChip === validation.locationId && !c.disabled)
        : null;
      if (chip && chip.getAttribute('aria-pressed') !== 'true') chip.click();
      const label = chip && chip.firstElementChild ? chip.firstElementChild.textContent : '';
      message((label ? label + ': ' : '') + validation.message);
      const fields = Array.from(dialog.querySelectorAll('[data-zone-field]'));
      const field = validation.fieldId
        ? fields.find(input => input.dataset.zoneField === validation.zoneId + ':' + validation.fieldId)
        : fields.find(input => !input.closest('[hidden]') && !input.disabled);
      if (!field) return;
      field.setAttribute('aria-invalid', 'true');
      field.setAttribute('aria-errormessage', 'gf-pz-unavailable');
      field.focus({ preventScroll: true });
      field.scrollIntoView({ block: 'nearest' });
    }
    // Sizes live on the page only. Personalized "(Personalized)" sizes are
    // never shown in the page's grid, so they never count as a picked size.
    function pdpSizePills() {
      const row = document.getElementById('size-row');
      if (!row) return [];
      return Array.from(row.querySelectorAll('.size-pill')).filter(pill =>
        pill.dataset.size != null && !pill.hidden && !/\(Personalized/.test(pill.dataset.size));
    }
    function sizeSelected() {
      const row = document.getElementById('size-row');
      return !row || pdpSizePills().some(pill => pill.classList.contains('is-active'));
    }
    function currentAddState(current) {
      const addBtn = document.getElementById('add-to-bag');
      const blocked = dialog.dataset.persBlocked === 'true';
      const selected = sizeSelected();
      const ctaPrice = document.getElementById('pd-cta-price');
      return addToBagState({
        sizeSelected: selected,
        blocked: blocked,
        unavailableLabel: selected && !blocked && addBtn && addBtn.disabled ? 'Out of stock' : '',
        priceText: ctaPrice ? ctaPrice.textContent.trim() : '',
        addonText: current.addonCents ? '+' + money(current.addonCents) : ''
      });
    }
    function hasReviewStep(current) {
      return !!(reviewEl && current.reviewable && engine && typeof engine.review === 'function');
    }
    function syncAction(current) {
      if (!save) return;
      const state = currentAddState(current);
      const view = editButtonState(state, hasReviewStep(current), current.addonCents ? '+' + money(current.addonCents) : '');
      const label = save.querySelector('[data-gf-pz-save-label]');
      if (label) label.textContent = view.label;
      save.querySelectorAll('[data-gf-pz-addon]').forEach(el => { el.textContent = view.price; });
      save.dataset.action = state.action;
      if (isReviewing()) syncReviewButton();
    }
    // -----------------------------------------------------------------
    // Review step (hanger mode, Grant 2026-11-02): every printed side at once,
    // the text of each spot, and a required spelling tick before the add. The
    // photos are the engine's own drawing, cloned (engine.review()). All of it
    // sits outside #pd-pers-zones; the edit screen is only hidden, so Edit goes
    // back to it with nothing lost.
    // -----------------------------------------------------------------
    let reviewRun = 0;
    function isReviewing() { return dialog.dataset.step === 'review'; }
    function setReviewError(text) {
      if (!reviewError) return;
      reviewError.textContent = text;
      reviewError.hidden = !text;
    }
    function syncReviewButton() {
      if (!reviewAdd || !reviewOk) return;
      const state = currentAddState(engine.status());
      const label = reviewAdd.querySelector('[data-gf-pz-review-add-label]');
      if (label) label.textContent = state.label;
      const price = reviewAdd.querySelector('[data-gf-pz-review-price]');
      if (price) price.textContent = state.price;
      reviewAdd.setAttribute('aria-disabled', String(!reviewOk.checked));
    }
    function renderReviewViews(views) {
      reviewViews.replaceChildren();
      views.forEach(view => {
        const figure = document.createElement('figure');
        figure.className = 'gf-pz-review-view is-loading';
        const frame = document.createElement('div');
        frame.className = 'gf-pz-review-frame';
        const img = document.createElement('img');
        img.className = 'gf-pz-review-img';
        img.alt = view.alt;
        // A side the shopper never opened still has to download.
        img.addEventListener('load', () => figure.classList.remove('is-loading'));
        img.addEventListener('error', () => {
          figure.classList.remove('is-loading');
          figure.classList.add('is-failed');
        });
        img.src = view.src;
        frame.appendChild(img);
        frame.appendChild(view.svgEl);
        const caption = document.createElement('figcaption');
        caption.className = 'gf-pz-review-caption';
        caption.textContent = view.label;
        figure.appendChild(frame);
        figure.appendChild(caption);
        reviewViews.appendChild(figure);
      });
    }
    function renderReviewSpots(rows) {
      reviewSpots.replaceChildren();
      rows.forEach(row => {
        const li = document.createElement('li');
        li.className = 'gf-pz-review-spot';
        const copy = document.createElement('div');
        copy.className = 'gf-pz-review-spot-copy';
        const where = document.createElement('span');
        where.className = 'gf-pz-review-spot-where';
        where.textContent = row.label;
        const text = document.createElement('strong');
        text.className = 'gf-pz-review-spot-text';
        text.textContent = row.text;
        copy.appendChild(where);
        copy.appendChild(text);
        // The ink is a swatch, its name for screen readers only (Grant dropped
        // ink wording from visible text).
        const ink = document.createElement('span');
        ink.className = 'gf-pz-review-swatch';
        ink.style.backgroundColor = row.inkHex;
        const inkName = document.createElement('span');
        inkName.className = 'gf-pz-visually-hidden';
        inkName.textContent = 'Color: ' + row.inkName;
        ink.appendChild(inkName);
        const price = document.createElement('span');
        price.className = 'gf-pz-review-spot-price';
        price.textContent = row.addonCents ? '+' + money(row.addonCents) : included;
        const edit = document.createElement('button');
        edit.type = 'button';
        edit.className = 'gf-pz-review-edit';
        edit.dataset.gfPzReviewEdit = row.id;
        edit.textContent = 'Edit';
        edit.setAttribute('aria-label', 'Edit ' + row.label);
        li.appendChild(copy);
        li.appendChild(ink);
        li.appendChild(price);
        li.appendChild(edit);
        reviewSpots.appendChild(li);
      });
    }
    function openReview(model) {
      if (dialog.contains(document.activeElement)) document.activeElement.blur();
      dialog.classList.remove('is-typing');
      message('');
      const run = ++reviewRun;
      renderReviewViews(model.views);
      renderReviewSpots(model.spots);
      reviewOk.checked = false;
      setReviewError('');
      dialog.dataset.step = 'review';
      reviewEl.hidden = false;
      syncReviewButton();
      dialog.scrollTop = 0;
      const body = reviewEl.querySelector('.gf-pz-review-body');
      if (body) body.scrollTop = 0;
      if (reviewTitle) reviewTitle.focus({ preventScroll: true });
      // Text fit depends on glyph metrics, and the engine's own fonts.ready
      // handler redraws only the main preview: redraw the copies too. The tick
      // is left alone.
      if (document.fonts && document.fonts.status !== 'loaded' && document.fonts.ready) {
        document.fonts.ready.then(() => {
          if (run !== reviewRun || !isReviewing()) return;
          const next = engine.review();
          if (next) renderReviewViews(next.views);
        });
      }
    }
    // Also runs on every close: the dialog is reused, and a reopen starts on the
    // edit screen with the tick clear.
    function clearReview() {
      if (!reviewEl) return;
      reviewRun++;
      delete dialog.dataset.step;
      reviewEl.hidden = true;
      if (reviewViews) reviewViews.replaceChildren();
      if (reviewSpots) reviewSpots.replaceChildren();
      if (reviewOk) reviewOk.checked = false;
      setReviewError('');
    }
    // Back to the edit screen, typed values intact. With a spot: that spot, its
    // first filled field focused. Synchronous inside the tap, or iOS opens no
    // keyboard.
    function closeReview(spotId) {
      if (!isReviewing()) return;
      clearReview();
      dialog.scrollTop = 0;
      const chip = spotId && Array.from(dialog.querySelectorAll('[data-wi-location-chip]')).find(c => c.dataset.wiLocationChip === spotId);
      if (chip) {
        chip.click();
        const fields = Array.from(dialog.querySelectorAll('[data-zone-field]')).filter(input => !input.closest('[hidden]') && !input.disabled);
        const field = fields.find(input => input.value) || fields[0];
        if (field) {
          field.focus();
          return;
        }
      }
      if (save) save.focus();
    }
    function unavailableMessage(state) {
      return state.label === 'Personalization unavailable'
        ? 'Personalization is unavailable for this selection.'
        : state.label + '. Choose another size or color.';
    }
    function confirmReview() {
      if (!editing || !engine || !isReviewing()) return;
      if (!reviewOk.checked) {
        setReviewError('Check the box first.');
        reviewOk.focus();
        return;
      }
      // #gf-pz-unavailable sits in the hidden edit screen: leave the review first.
      const validation = engine.validate();
      if (!validation.valid) {
        closeReview();
        showValidation(validation);
        return;
      }
      const state = currentAddState(engine.status());
      if (state.action === 'none') {
        closeReview();
        message(unavailableMessage(state));
        return;
      }
      engine.markReviewed(REVIEW_VERSION);
      finishAdd(state);
    }
    function sync() {
      document.querySelectorAll('[data-gf-pz-open]').forEach(button => { button.disabled = !engine; });
      if (!engine) return;
      const current = engine.status();
      syncAction(current);
      if (!entry || !savedStatus) return;
      const hasSaved = savedStatus.filledLocations > 0;
      const summary = entry.querySelector('[data-gf-pz-summary]');
      const saved = entry.querySelector('[data-gf-pz-saved]');
      const trigger = entry.querySelector('[data-gf-pz-open]');
      const offer = entry.querySelector('[data-gf-pz-offer]');
      if (summary) summary.textContent = savedStatus.summary;
      if (saved) saved.hidden = !hasSaved;
      if (trigger) trigger.textContent = hasSaved ? trigger.dataset.editLabel : entryLabelForMode(storePersonalizationMode(), trigger.dataset.entryLabel);
      if (offer) offer.textContent = hasSaved ? addonText(savedStatus)
        : current.perLocationCents === 0 ? included
          : (current.varyingRates ? 'From ' : '') + '+' + money(current.perLocationCents) + ' ' + (dialog.dataset.locationLabel || 'per location');
    }
    // Phone + hanger mode = an Apple-style bottom sheet (Grant 2026-10-02,
    // after Apple's AirPods engraving sheet): ONE natural scroll, nothing
    // pinned, and nothing resized by script while the keyboard moves (that
    // resizing is what made the old modal jump).
    function isPhoneSheet() {
      return dialog.classList.contains('is-wisconsin') && window.matchMedia('(max-width: 699.98px)').matches;
    }
    // Focus in Name / Number: glide the sheet so the preview's top sits at the
    // top of the screen with the fields right under it (what Apple does), and
    // zoom the preview onto the spot being edited while typing.
    function revealPreviewForTyping() {
      const preview = dialog.querySelector('.gf-pz-preview');
      if (!preview) return;
      const top = dialog.scrollTop + (preview.getBoundingClientRect().top - dialog.getBoundingClientRect().top);
      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      dialog.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function syncViewport() {
      // Hanger mode is full screen at every width: the CSS sizes it.
      if (dialog.classList.contains('is-wisconsin')) {
        dialog.dataset.compact = 'false';
        dialog.style.top = '';
        return;
      }
      const viewport = window.visualViewport;
      const height = Math.round((viewport && viewport.height) || window.innerHeight || 0);
      if (!height) return;
      const top = Math.round((viewport && viewport.offsetTop) || 0);
      const stacked = window.matchMedia('(max-width: 699.98px)').matches;
      // visualViewport includes Safari chrome and keyboard changes. Keep the
      // preview and footer in distinct rows, giving only the fields scrolling.
      const dialogHeight = stacked ? height : Math.min(Math.round(height * .94), 840);
      dialog.style.setProperty('--gf-pz-vvh', height + 'px');
      dialog.style.setProperty('--gf-pz-dialog-h', dialogHeight + 'px');
      dialog.dataset.compact = String(stacked && height < 540);
      if (dialog.open) {
        dialog.style.top = top + Math.round((height - dialogHeight) / 2) + 'px';
        const field = document.activeElement;
        const pane = dialog.querySelector('.gf-pz-form-inner');
        if (pane && field && pane.contains(field) && field.matches('[data-zone-field]')) {
          const fieldBox = field.getBoundingClientRect();
          const paneBox = pane.getBoundingClientRect();
          if (fieldBox.bottom > paneBox.bottom) pane.scrollTop += fieldBox.bottom - paneBox.bottom;
          else if (fieldBox.top < paneBox.top) pane.scrollTop -= paneBox.top - fieldBox.top;
        }
      }
    }
    function closeEditor(commit) {
      if (!editing) return;
      editing = false;
      clearReview();
      if (!commit && savedSnapshot) engine.restore(savedSnapshot);
      document.documentElement.classList.remove('gf-pz-is-open');
      message('');
      sync();
      if (dialog.open) {
        if (typeof dialog.close === 'function') dialog.close(commit ? 'saved' : 'cancelled');
        else dialog.removeAttribute('open');
      }
      dialog.style.top = '';
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    }
    function openEditor(button) {
      if (!engine || editing) return;
      opener = button;
      savedSnapshot = engine.snapshot();
      savedStatus = engine.status();
      editing = true;
      analytics('personalization_opened', { product_handle: productHandle, placement: activePlacement(), action_id: 'personalization-open-' + (++analyticsAction) });
      message('');
      // Start on the front photo with no location picked (Grant 2026-10-02).
      if (typeof engine.start === 'function') engine.start();
      dialog.classList.remove('is-typing');
      dialog.scrollTop = 0;
      document.documentElement.classList.add('gf-pz-is-open');
      syncViewport();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      // showModal() focuses the first button (the x), and the theme's focus
      // ring drew a coloured circle around it on open (Grant 2026-10-03).
      // Focus the sheet itself; Tab still reaches the x with its ring.
      dialog.focus({ preventScroll: true });
      syncViewport();
      sync();
    }
    // Size first (Grant, iPhone pass 2026-10-02): the modal's button should
    // always add to bag, so Personalize asks for a size before it opens. The
    // page behind an open dialog is inert, so sizes can't be picked from it.
    document.querySelectorAll('[data-gf-pz-open]').forEach(button => {
      on(button, 'click', () => {
        if (!sizeSelected()) {
          feedback('error', 'Choose your size first, then personalize.');
          const row = document.getElementById('size-row');
          const first = row && row.querySelector('.size-pill:not(:disabled)');
          if (row) {
            const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            row.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          }
          if (first) first.focus({ preventScroll: true });
          return;
        }
        openEditor(button);
      });
    });
    // A size picked after that prompt clears it.
    on(document, 'click', event => {
      if (!editing && event.target.closest && event.target.closest('#size-row') && sizeSelected()
        && dialog.dataset.feedback === 'error') feedback('', '');
    });
    dialog.querySelectorAll('[data-gf-pz-close]').forEach(button => {
      on(button, 'click', () => closeEditor(false));
    });
    // Back to the tiles. Typed values stay: only the picked spot is put away.
    const spots = dialog.querySelector('[data-gf-pz-spots]');
    if (spots) on(spots, 'click', () => {
      if (!engine || typeof engine.start !== 'function') return;
      engine.start();
      dialog.classList.remove('is-typing');
      dialog.scrollTop = 0;
      sync();
    });
    // Esc in the review goes back to editing; on the edit screen it discards,
    // as it always has. The review has no backdrop action at all.
    function handleCancel(event) {
      event.preventDefault();
      if (isReviewing()) {
        closeReview();
        return;
      }
      closeEditor(false);
    }
    on(dialog, 'cancel', handleCancel);
    on(dialog, 'click', event => { if (event.target === dialog && !isReviewing()) closeEditor(false); });
    if (reviewBack) on(reviewBack, 'click', () => closeReview());
    if (reviewOk) on(reviewOk, 'change', () => {
      setReviewError('');
      syncReviewButton();
    });
    if (reviewAdd) on(reviewAdd, 'click', confirmReview);
    if (reviewSpots) on(reviewSpots, 'click', event => {
      const edit = event.target.closest && event.target.closest('[data-gf-pz-review-edit]');
      if (edit) closeReview(edit.dataset.gfPzReviewEdit);
    });
    // Also covers native dialog dismissal outside our own buttons.
    on(dialog, 'close', () => closeEditor(false));
    // Set when the modal sends the shopper's personalization to the cart, so
    // the matching gf:cart-added resets the editor even if the shopper has
    // reopened the modal while /cart/add.js was in flight.
    let pendingAdd = false;
    function commitAndClose(status) {
      savedSnapshot = engine.snapshot();
      savedStatus = engine.status();
      closeEditor(true);
      feedback('success', status);
      analytics('personalization_saved', { product_handle: productHandle, placement: activePlacement(), action_id: 'personalization-save-' + (++analyticsAction) });
      dialog.dispatchEvent(new CustomEvent('gf:pers-commit', { bubbles: true, detail: savedStatus }));
    }
    // The one button: validate, then the review step where the store has one
    // (hanger mode), else straight on to finishAdd. finishAdd adds (size already
    // picked on the page) or saves and sends the shopper to the page's size row.
    // Adding submits #pd-form:
    // the engine's submit listener writes the per-location properties and
    // gf-storefront.js adds via /cart/add.js with the "(Personalized ×k)"
    // variant, opens the cart drawer and announces gf:cart-added.
    if (save) on(save, 'click', () => {
      if (!editing || !engine) return;
      const validation = engine.validate();
      if (!validation.valid) {
        showValidation(validation);
        return;
      }
      const state = currentAddState(engine.status());
      if (state.action === 'none') {
        message(unavailableMessage(state));
        return;
      }
      // engine.review is on the API for every store: null means no review step.
      const model = hasReviewStep(engine.status()) ? engine.review() : null;
      if (model) {
        openReview(model);
        return;
      }
      finishAdd(state);
    });
    function finishAdd(state) {
      if (state.action === 'save') {
        commitAndClose('Personalization saved. Choose your size, then Add to Bag.');
        const row = document.getElementById('size-row');
        const first = row && row.querySelector('.size-pill:not(:disabled)');
        if (row) {
          const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          row.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        }
        if (first) first.focus({ preventScroll: true });
        return;
      }
      const form = document.getElementById('pd-form') || document.querySelector('form[action*="/cart/add"]');
      if (!form) {
        closeReview();
        message('Add to bag is unavailable on this page.');
        return;
      }
      commitAndClose('Adding to bag…');
      pendingAdd = true;
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
    // Added (from the modal or the page's own button): clear the editor so the
    // next item starts blank (Grant 2026-10-02). A page add while the modal is
    // open (cannot happen: the page is inert) is left alone.
    on(document, 'gf:cart-added', () => {
      if (!engine || (editing && !pendingAdd)) return;
      pendingAdd = false;
      engine.reset();
      savedSnapshot = engine.snapshot();
      savedStatus = engine.status();
      sync();
      if (!editing) feedback('success', 'Added to bag.');
      dialog.dispatchEvent(new CustomEvent('gf:pers-commit', { bubbles: true, detail: savedStatus }));
    });
    // Not added: the personalization stays saved on the page for a retry.
    on(document, 'gf:cart-add-failed', () => {
      pendingAdd = false;
      if (editing) return;
      feedback('error', 'Could not add to bag. Your personalization is saved; try Add to Bag again.');
    });
    // A size or color picked on the page itself changes the modal's sizes,
    // stock and price. Bubble phase: the PDP's own handler has resolved first.
    on(document, 'click', event => {
      if (event.target.closest && event.target.closest('#size-row, #swatch-row')) sync();
    });
    on(dialog, 'focusin', event => {
      if (!dialog.classList.contains('is-wisconsin') || !event.target.matches || !event.target.matches('[data-zone-field]')) return;
      const wasTyping = dialog.classList.contains('is-typing');
      dialog.classList.add('is-typing');
      if (!wasTyping && isPhoneSheet()) revealPreviewForTyping();
    });
    on(dialog, 'focusout', event => {
      // Name -> Number keeps the zoom; leaving the fields zooms back out.
      const next = event.relatedTarget;
      if (next && next.matches && next.matches('[data-zone-field]')) return;
      dialog.classList.remove('is-typing');
    });
    on(dialog, 'input', () => message(''));
    on(dialog, 'change', () => message(''));
    if (entry) {
      const remove = entry.querySelector('[data-gf-pz-remove]');
      if (remove) on(remove, 'click', () => {
        if (!engine) return;
        engine.reset();
        savedSnapshot = engine.snapshot();
        savedStatus = engine.status();
        sync();
        dialog.dispatchEvent(new CustomEvent('gf:pers-commit', { bubbles: true, detail: savedStatus }));
      });
    }
    // No cart path may serialize an uncommitted editor draft. Capture runs
    // before the production engine's property writer and storefront handler.
    on(document, 'submit', event => {
      if (!editing || !event.target.matches('form[action*="/cart/add"]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
    on(document, 'gf:pers-ready', () => {
      engine = window.GhostFitPersonalization;
      savedSnapshot = engine.snapshot();
      savedStatus = engine.status();
      sync();
    });
    on(document, 'gf:pers-state', () => {
      if (engine && !editing) savedStatus = engine.status();
      sync();
    });
    if (window.visualViewport) {
      on(window.visualViewport, 'resize', syncViewport);
      on(window.visualViewport, 'scroll', syncViewport);
    }
    on(window, 'resize', syncViewport);
    on(window, 'orientationchange', syncViewport);
    dispose = function () { closeEditor(false); listeners.abort(); };
    syncViewport();
    sync();
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
